//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,

    constants: {
        optionHeight: 48,
    },

    props: {
        options: Array,
        separatorIndex: Number,

        // Note: Defined as props so that empty string gets interpreted as true
        hideDropdownIcon: Boolean,
        useInput: Boolean,
    },

    data() {
        return {
            optionProps: [],
            optionEvents: [],
            focusedIndex: null,
        };
    },

    computed: {
        optionsHeight() {
            return this.options.length * this.optionHeight + (this.separatorIndex >= 0 ? 2 : 0);
        },
    },

    methods: {
        getLabel(option) {
            const attr = this.$attrs['option-label'];

            return (
                typeof attr === 'function' ? attr(option) :
                typeof attr === 'string' ? _.get(option, attr) :
                typeof option === 'object' ? option.label :
                option
            );
        },
        // This hack enables passing item props and events to options
        // rendered in custom scroll area in before-options slot
        saveOptionData(index, itemProps, itemEvents) {
            this.optionProps[index] = itemProps;
            this.optionEvents[index] = itemEvents;

            if (itemProps.focused) {
                this.focusedIndex = index;
            }
        },
        scrollToIndex(index) {
            if (!this.$refs.options)
                return;

            const height = Math.min(this.optionsHeight, document.documentElement.clientHeight * .65);
            const oldY = this.$refs.options.getScrollPosition();
            const minNewY = this.optionHeight * (index + 1) - height;
            const maxNewY = this.optionHeight * index;

            if (oldY < minNewY) {
                this.$refs.options.setScrollPosition(minNewY);
            } else if (oldY > maxNewY) {
                this.$refs.options.setScrollPosition(maxNewY);
            }
        },
        onKeyDown() {
            setTimeout(() => {
                this.scrollToIndex(this.focusedIndex, false);
            }, 1);
        },
    },
};
